import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { DataTestIds } from "@regrello/data-test-ids-api";
import { RegrelloButton, RegrelloInput } from "@regrello/ui-core";

export function TeamEmailContent({
  isLoading,
  requestVerification,
  setEmail,
}: {
  isLoading: boolean;
  requestVerification: (e: React.FormEvent<HTMLFormElement>) => void;
  setEmail: (email: string) => void;
}) {
  return (
    <form className="flex flex-col mt-10 gap-10 items-center" onSubmit={requestVerification}>
      <h1 className="flex items-center text-4xl md:text-5xl">{t`Verify your email`}</h1>

      <p className="text-base">
        <Trans>
          This task was assigned to a team. To continue, please enter your own work email address (must be a member of
          the team). We’ll send you a secure link to verify and open the task.
        </Trans>
        <br />
        <Trans>If you believe this page wasn’t meant for you, please close this window.</Trans>
      </p>

      <RegrelloInput
        className="w-full"
        onChange={(e) => {
          setEmail(e.currentTarget.value);
        }}
        placeholder={t`example@example.com`}
        required={true}
        title={t`This task was assigned to a team. To continue, please enter your own work email address (must be a member of the team). We’ll send you a secure link to verify and open the task.`}
        type="email"
      />

      <RegrelloButton
        className="w-full p-3.5 capitalize"
        dataTestId={DataTestIds.VERIFY_DEVICE_BUTTON}
        intent="primary"
        loading={isLoading}
        type="submit"
      >
        {t`Send verification email`}
      </RegrelloButton>
    </form>
  );
}
